// removed by extract-text-webpack-plugin
module.exports = {"root":"featured-shows__root","heading":"featured-shows__heading","list":"featured-shows__list","show":"featured-shows__show","showLink":"featured-shows__showLink","showImage":"featured-shows__showImage","showCallout":"featured-shows__showCallout"};


//////////////////
// WEBPACK FOOTER
// ./src/show-index/components/featured-shows/styles.less
// module id = 475
// module chunks = 3